<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import CKEditor from "@ckeditor/ckeditor5-vue";
   import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
    
   export default {
      page: {
         title: "About",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader, ckeditor: CKEditor.component },
      data() {
         return {
            title: "About",
            items: [
               
               {
                  text: "About",
                  active: true,
               },        
            ],
            about:{              
               content: "",
},
           description: "", 

            type: "",
            user_id: "",
            errors: {},
             error:"",
            cms: {

                title: "About Dhaamiye",
               editor: ClassicEditor,
               content: "<p>RSD is a mobile application platform for ordering fuel for your car from the convenience of your smartphone. We have set ourselves as an end-to-end technology platform and service provider emphasizing the software and hardware needs of mobile fueling companies, regardless of if they are direct to individual, commercial, fleet, and/or enterprise vehicles. By using the Dhaamiye app, your gas tank can be filled up while you go about your day.</p><p>We will come directly to your location and fuel up &nbsp;as many vehicles as your business needs.&nbsp;This will help save time and save money by&nbsp;eliminating the need to send employees to put&nbsp;&nbsp;fuel into your vehicles.</p><h2>Download the Apple App Store and Google Play Store.</h2><h1>Download Today</h1><ol><li>OPEN THE APP</li><li>BOOK YOUR FEUL DELIVERY</li><li>OPEN YOUR GAS FLAP</li></ol>",
               editorConfig: {
                    
               }
            }
         };
      },
      mounted() {
    
      },
      created() {
         this.fetchAbout();
      },

     methods: {

         
  numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         noSpaces(event) {
            let keyCode = event.keyCode;
            if(keyCode == 32) {
               event.preventDefault();
            } else {
               return;
            }
         },

         alphaSpacesOnly(event) {
            let keyCode = event.keyCode;
            if ((keyCode >= 65 && keyCode <= 90) || 
               (keyCode >= 97 && keyCode <= 122) ||               
               (keyCode == 32)) {
                 return;
            } else {
               event.preventDefault();
            }
         },

         getToken() {
         if (localStorage.getItem('sigohealth_admin')) {
            var sigohealth_admin =  JSON.parse(localStorage.getItem('sigohealth_admin'));
            if(sigohealth_admin.token) {
               this.token = sigohealth_admin.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
               
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      }, 

         fetchAbout() {
            let url = "api/cms/about-us/details";         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
                var responseData = res.data.data;
               console.log(responseData);
               this.about = responseData;  
                     
            })
              .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
            //.finally(() => (this.loading = false));
         },
        
         updateAbout() {
            this.getToken();           
             this.errors = {};

            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/cms/about-us";

            let formData = new FormData();
            formData.append("content", this.about.content); 
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'cms.about'});

               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                 
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="updateAbout()">
                        <div class="row"> 
                    
                           <b-form-group class="col-lg-12 mb-3" >
                              <label>Content <span class="text-danger">*</span></label>
                              <ckeditor v-model="about.content" :editor="cms.editor" :config="cms.editorConfig"></ckeditor> 
                           </b-form-group> 
                           <div v-if="errors.content" class="text-danger">
                              <div v-for="(error, index) in errors.content" :key="index">{{ error }}</div>
                           </div>               
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <button class="btn btn-primary me-2" type="submit">Update</button>
                              
                           </div>
                        </div>
                     </form>

                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
